/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Description_AppearanceInputs */

const en_settings_description_appearance = /** @type {(inputs: Settings_Description_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize tenant branding assets.`)
};

const de_settings_description_appearance = /** @type {(inputs: Settings_Description_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passen Sie die Branding-Assets des Mandanten an.`)
};

/**
* | output |
* | --- |
* | "Customize tenant branding assets." |
*
* @param {Settings_Description_AppearanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_description_appearance = /** @type {((inputs?: Settings_Description_AppearanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Description_AppearanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_description_appearance(inputs)
	return de_settings_description_appearance(inputs)
});